// @flow
import React, { Component } from 'react';
import { TextInput, View } from 'react-native';

import theme from '../../../theme-config';
import StyleSheet from '../../../lib/rtl-aware-stylesheet';

class TripicaTextArea extends Component<Props> {
  styles = getStyles();
  textInputRef: any;

  setTextInputRef = (textInputRef: any) => {
    this.textInputRef = textInputRef;
  };

  render() {
    const styles = this.styles;
    const { style: containerStyle, input, ...otherProps } = this.props;

    return (
      <View style={[styles.inputContainer, containerStyle]}>
        <TextInput
          ref={this.setTextInputRef}
          underlineColorAndroid="transparent"
          multiline={true}
          numberOfLines={2}
          maxLength={250}
          placeholderTextColor={theme.signUpTextAreaPlaceholderColor}
          style={styles.text}
          {...otherProps}
          {...input}
        />
      </View>
    );
  }

  focus = () => {
    if (this.props.disabled) {
      return;
    }
    this.textInputRef && this.textInputRef().focus();
  };

  blur = () => {
    this.textInputRef && this.textInputRef().blur();
  };
}

type Props = {
  style: any,
  value: string,
  input: Object,
  disabled?: boolean,
};

function getStyles() {
  return StyleSheet.create({
    text: {
      fontFamily: theme.fontFamily,
      fontSize: 18,
      color: theme.signUpInputTextColor,
      flex: 1,
      minHeight: 68,
    },
    inputContainer: {
      borderRadius: 3,
      backgroundColor: theme.signUpTextAreaBackgroundColor,
      flexDirection: 'row',
      paddingHorizontal: 6,
      paddingTop: 5,
      paddingBottom: 10,
    },
  });
}

export default TripicaTextArea;
